package com.eladfinish.bible.contest.common.usecases

import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.data.common.stringResolver.StringResolver
import com.eladfinish.bible.contest.perek_str_hebrew
import com.eladfinish.bible.contest.utils.addGershaim
import dev.icerock.moko.resources.desc.desc

class GetBookAndChapterPrefixedByPerekUseCase(
    private val stringResolver: StringResolver,
) {

    operator fun invoke(
        book: String,
        chapter: String,
        onlyBook: Boolean = false,
    ): String =
        if (onlyBook) {
            book
        } else {
            "$book ${stringResolver.resolveString(SharedRes.strings.perek_str_hebrew.desc())} ${chapter.addGershaim()}"
        }

}
